import { Model } from '@vuex-orm/core';

export default class Slug extends Model {
  static entity = 'slug';

  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number | null} */
    this.id;
    /** @type {string} */
    this.title;
    /** @type {string} */
    this.slug;
    /** @type {string} */
    this.path;
    /** @type {string} */
    this.description;
  }

  static fields() {
    return {
      id: this.number(0).nullable(),
      title: this.string(''),
      slug: this.string(''),
      path: this.string(''),
      description: this.string('')
    };
  }
}
